import { BoxProps } from 'flatiron';
import { Props as TextProps } from 'flatiron/Text/Text';

import { ActionName, EventName } from './lib/actionNames';

export type WebSocketBulkOperationEvent = {
  action: 'notification' | 'ACTIVITY';
  actionName: ActionName;
  data: {
    action_data?: {
      data: {
        errors?: string[];
      };
    };
    event: EventName;
    state: 'IDLE' | 'PROCESSING' | 'DONE' | 'ERROR';
    stages?: {
      description: string;
      status: string;
      details: {
        error: string | null;
        count: number | null;
      };
    }[];
    user_id: string;
    context: { [key: string]: any };
  };
};

export type WebSocketProgressEvent = {
  action: 'notification';
  actionName: ActionName;
  data: {
    total_completed: number;
    total_to_complete: number;
  };
};

export enum Status {
  IDLE,
  PROCESSING,
  DONE,
  ERROR,
}

export type ProgressDescriptionSettings = {
  actionButton?: () => ProgressDescription['actionButton'];
  description?: () => ProgressDescription['description'];
  notes?: () => ProgressDescription['notes'];
  styles?: () => ProgressDescription['styles'];
  subTitle?: () => ProgressDescription['subTitle'];
  title: () => ProgressDescription['title'];
};

export type ProgressDescription = {
  actionButton?: {
    title: string;
    handler: () => void;
  } | null;
  styles?: Styles | null;
  description?: string;
  notes?: string;
  subTitle?: string;
  title: string;
};

export type ProgressDescriptionKeys = keyof ProgressDescription;

export type Styles = {
  [key: string]: BoxProps | TextProps | null;
};

export enum KindProgressBar {
  determinate = 'determinate',
  indeterminate = 'indeterminate',
}

export enum ProgressActions {
  add = 'add',
  assign = 'assign',
  delete = 'delete',
  clone_listing = 'clone_listing',
  move_products = 'move_products',
  move_packages = 'move_packages',
  price = 'price',
  remove = 'remove',
  removefromallocation = 'removefromallocation',
  upload_offer = 'upload_offer',
}
